export default __webpack_public_path__ + "static/14(1)-fafc478c3b20ad32796dcde6130e8f22.png";